module.exports = __webpack_public_path__ + "img/apidays-2022-snapshot-trevor-1.d647549f.jpg";